import Firebase from 'firebase';
//TODO : Check alternative
import {CricrushConfig, strings} from './../../cc-imports'
import _ from 'lodash'
const baseUrl = 'http://localhost:3000/?';
const FirebaseInvitesUtils = {

    composeLink(params) {
        var url = baseUrl;

        var index=0;
        _.forIn(params,(value,key)=>{
            if(value && key){
                url = url + (index==0?'':'&') + key + '=' + value;
                index++;
            }
        });

        return url;
    },

    extractLinks(url) {
        // var url = parse(url, true);
        // var linkParams = {};
        // var params = {};
        // if(url.query && url.query.link){
        //     linkParams = parse(url.query.link, true);
        //     if(linkParams.query){
        //         params = linkParams.query;
        //     }
        // }
        // else {
        //     params = url.query;
        // }
        // return params;
    },

    //verified
    showInviteLinkDialog(params, user) {

        var url = FirebaseInvitesUtils.composeLink(params);

        var link =new Firebase.links.DynamicLink(url, CricrushConfig.dynamicLinkDomain)
            .android.setPackageName('com.cricrush')
            .ios.setBundleId('com.cricrush.iosv1');

        const userName = (user.displayName && user.displayName != null) ? user.displayName:'';

        Firebase.links().createShortDynamicLink(link, 'SHORT').then((url) => {
            FirebaseInvitesUtils.showShareDialog(strings('invite_friends_share_message', { name : userName }),strings('invite_friends_share_title', { name : userName }), url, strings('invite_friends_dialog_title'))
        })
    },
    //verified
    showShareDialog(message, title, url, dialogTitle) {
        var content = {
            title : title,
            message : message + '. '+url
        };
        // if (Platform.OS === 'ios') {
        //     Share.share(content, {
        //         excludedActivityTypes: [
        //             'com.apple.UIKit.activity.PostToTwitter'
        //         ],
        //         subject: title
        //     });
        // }
        // else if (Platform.OS === 'android') {
        //     content.message = message +' '+url;
        //     Share.share(content, {
        //         dialogTitle: dialogTitle
        //     });
        // }
    },
    //verified
    getInitialLinkParams(callback){
        const url_string = window.location.href; //window.location.href
        const url = new URL(url_string);
        const invitedById = url.searchParams.get("invitedBy");

        callback(invitedById);
    },
    //verified
    subscribeToOnLinkEvents(callback) {
        const url_string = window.location.href; //window.location.href
        const url = new URL(url_string);
        const invitedById = url.searchParams.get("invitedBy");

        callback(invitedById);
    },





    redirectBasedOnInviteLinks(ccTabNavigation, actions) {
        FirebaseInvitesUtils.extractInviteLinkDetails(function(urlParams) {
            //console.log('Final Link', urlParams);
            if (urlParams && urlParams.leagueId) {
                let leagueTitle = urlParams.leagueTitle ? urlParams.leagueTitle.replace(new RegExp('\\+', 'g'),' ') : '';
                actions.openSingleLeague({
                    id: urlParams.leagueId,
                    name: decodeURIComponent(leagueTitle)
                }, ccTabNavigation);
            }
        });
    },

    getInviteDetails(callback) {
        try {
            FirebaseInvitesUtils.extractInviteLinkDetails(function(urlParams) {
                if (urlParams && urlParams.invitedBy) {
                    callback(urlParams.invitedBy);
                } else {
                    callback(null);
                }
            })
        } catch (err) {
            callback(null);
        }
    },

    extractInviteLinkDetails(callback) {
        Firebase.links()
            .getInitialLink()
            .then((url) => {
                try {
                    if (url) {
                        var urlParams = {};

                        url.replace(
                            new RegExp("([^?=&]+)(=([^&]*))?", "g"),
                            function($0, $1, $2, $3) {
                                urlParams[$1] = $3;
                            }
                        );

                        // ios have diffrent url, here i replace the url for ios devices only

                        if (urlParams && urlParams.link) {
                            let decodeUrl = decodeURIComponent(urlParams.link);

                            decodeUrl.replace(
                                new RegExp("([^?=&]+)(=([^&]*))?", "g"),
                                function($0, $1, $2, $3) {
                                    urlParams[$1] = $3;
                                }
                            );
                        }

                        if (callback) {
                            callback(urlParams);
                        }
                    }
                    else {
                        callback();
                    }

                } catch (e) {
                    //console.log(e, 'ERROR');
                    callback(null);
                }


            }).catch((err)=>{
            callback();
        });
    }

};

export default FirebaseInvitesUtils;


// WEBPACK FOOTER //
// ./src/app/lib/firebase/FirebaseInvitesUtils.js